import { Component, ComponentFactoryResolver, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WrapperComponent } from '../wrapper/wrapper.component';

@Component({
	selector: 'ws-wrapper',
	template: `<div class="slide-modal">
		<ng-container #componentContainer></ng-container>
	</div>`,
})
export class DialogWrapperComponent extends WrapperComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		route: ActivatedRoute,
		componentFactoryResolver: ComponentFactoryResolver
	) {
		super(route, componentFactoryResolver);

		this.componentType = this.data.componentType;
		this.componentInputs = this.data.componentInputs;
	}
}
